import { renderWithLoader } from '@meteor/data-hooks';
import { Button } from '@meteor/ui';
import { Table, TextField } from '@radix-ui/themes';
import { useState } from 'react';
import { earlyAccessState } from '../../state';

export let EarlyAccessPage = () => {
  let [after, setAfter] = useState<string | undefined>();
  let [search, setSearch] = useState<string | undefined>();

  let earlyAccess = earlyAccessState.use({
    search,
    after
  });

  return renderWithLoader({ earlyAccess })(({ earlyAccess }) => (
    <>
      <form
        style={{ marginBottom: 20 }}
        onSubmit={e => {
          e.preventDefault();
          let formData = new FormData(e.target as HTMLFormElement);
          let search = formData.get('search') as string;
          setSearch(search);
        }}
      >
        <TextField.Root
          placeholder="Search"
          name="search"
          defaultValue={search}
        ></TextField.Root>
      </form>

      <Table.Root variant="surface">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Email</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Role @ Company</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Campaign</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Referrer</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Ticket ID</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Created At</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell></Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {earlyAccess.data.map(earlyAccess => (
            <Table.Row key={earlyAccess.xata_id}>
              <Table.Cell>{earlyAccess.name}</Table.Cell>
              <Table.Cell>{earlyAccess.email}</Table.Cell>
              <Table.Cell>
                {[earlyAccess.role, earlyAccess.company].filter(Boolean).join(' @ ')}
              </Table.Cell>
              <Table.Cell>{earlyAccess.campaign}</Table.Cell>
              <Table.Cell>{earlyAccess.referrer}</Table.Cell>
              <Table.Cell>{earlyAccess.ticketId}</Table.Cell>
              <Table.Cell>{earlyAccess.xata_createdat.toLocaleDateString('de-at')}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

      <Button
        size="1"
        style={{ marginTop: 20 }}
        onClick={() => setAfter(earlyAccess.data[earlyAccess.data.length - 1]?.xata_id)}
      >
        Load More
      </Button>
    </>
  ));
};
